<template>
  <v-content class="pa-0">
    <v-card-title class="grey lighten-3">
      <v-row>
        <v-icon class="draggable">mdi-drag</v-icon>
        <v-col class="py-0">{{ departmentLabel }}</v-col>
      </v-row>
    </v-card-title>
    <v-card-text class="pa-3">
      <v-container fluid grid-list-md class="pa-0">
        <v-layout row wrap>
          <v-flex sm6>
            <v-text-field
              label="Name"
              v-model="d.name"
              @input="$v.d.name.$touch()"
              @blur="$v.d.name.$touch()"
              :error-messages="nameErrors"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
          <v-flex sm6>
            <taxes-list-select
              :taxType="d.taxType"
              @onSelectTaxType="onSelectTaxType($event)"
              :doResetSelectedTax="doResetSelectedTax"
              @onSelectedTaxReset="onSelectedTaxReset"
              :outlined="outlinedInputs"
            ></taxes-list-select>
          </v-flex>
          <v-flex sm3>
            <v-text-field
              label="Sales Nominal Code"
              v-model="d.salesNominalCode"
              @input="$v.d.salesNominalCode.$touch()"
              @blur="$v.d.salesNominalCode.$touch()"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
          <v-flex sm3>
            <v-text-field
              label="Purchase Nominal Code"
              v-model="d.purchaseNominalCode"
              @input="$v.d.purchaseNominalCode.$touch()"
              @blur="$v.d.purchaseNominalCode.$touch()"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex sm6>
            <v-text-field label="Code" v-model="d.code" :outlined="outlinedInputs"></v-text-field>
          </v-flex>
          <v-flex sm6>
            <v-checkbox label="Not In Use" v-model="d.notInUse" primary hide-details></v-checkbox>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-content>
</template>

<script>
import {
  DEPARTMENT_UPDATE_MUTATION,
  DEPARTMENT_CREATE_MUTATION
} from "../../../../constants/graphql";
import TaxesListSelect from "../../shared/TaxesListSelect";
import { required } from "vuelidate/lib/validators";

export default {
  name: "DepartmentEditor",

  components: {
    TaxesListSelect
  },

  props: {
    department: {
      type: Object,
      default: () => ({})
    },

    doSaveDepartment: {
      type: Boolean,
      default: false
    },

    departmentEditorDialog: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      d: { ...this.department },
      debug: false,
      doResetSelectedTax: false
    };
  },

  methods: {
    saveDepartment() {
      this.$emit("onResetSave");
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let mutation =
          this.context == "edit"
            ? DEPARTMENT_UPDATE_MUTATION
            : DEPARTMENT_CREATE_MUTATION;
        this.$apollo
          .mutate({
            mutation: mutation,
            variables: {
              ...this.d
            }
          })
          .then(this.saveGqlObjectHandler, this.saveGqlObjectErrorHandler);
      }
    },
    saveGqlObjectHandler(result) {
      this.resetSelectedTax();
      this.$emit("saved", this.context);
    },
    saveGqlObjectErrorHandler(err) {
      console.log(err);
    },
    onSelectTaxType(data) {
      this.d.taxType = data.description;
    },
    resetSelectedTax() {
      this.doResetSelectedTax = true;
    },
    onSelectedTaxReset() {
      this.doResetSelectedTax = false;
    }
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    departmentLabel() {
      return this.department.id != null
        ? this.department.name
        : "New Department";
    },
    context() {
      return this.department.id != null ? "edit" : "create";
    },
    nameErrors() {
      let errors = [];
      if (!this.$v.d.name.$dirty) {
        return errors;
      }
      if (!this.$v.d.name.required) {
        errors.push("Department is required.");
      }
      return errors;
    }
  },

  watch: {
    department(data) {
      let department = { ...data };
      delete department.__typename;
      this.d = department;
    },
    departmentEditorDialog(value) {
      if (!value) {
        this.d = {};
        this.resetSelectedTax();
        this.$v.$reset();
      }
    },
    doSaveDepartment(value) {
      if (value) {
        this.saveDepartment();
      }
    }
  },
  validations: {
    d: {
      name: { required }
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/gt/admin/department-types/DepartmentEditor.vue